import axios from "axios";

const axiosClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL,

  timeout: 60000,

  headers: {
    "Content-Type": "application/json",
  },
});

axiosClient.interceptors.response.use(

  (response) => response,

  (error) => {

    const message =
      error?.response?.data?.error ||
      error?.message ||
      "Something went wrong";

    return Promise.reject(
      new Error(message)
    );
  }
);

export default axiosClient;